<template>
  <div>
    <div class="pa-4 d-flex align-center">
      <v-btn v-if="folder" icon @click="onPrev">
        <v-icon> mdi-chevron-left </v-icon>
      </v-btn>
      <div :key="folder" class="title">
        {{ folder ? storedPaths[folder] || cloudName : cloudName }}
      </div>
      <div class="ml-auto d-flex align-center">
        <template v-if="['ADMIN', 'ASSISTANT'].includes($store.state.profile.role)">
          <CreateFolder @new-file="addItem" @new-folder="addItem" />
          <CreateFile v-if="folder" @new-file="addItem" />
        </template>
        <v-switch
          v-model="details"
          color="pink"
          inset
          label="List"
          class="d-inline-flex my-0 ml-4 font-weight-bold"
          hide-details
        />
      </div>
    </div>
    <v-divider />

    <keep-alive>
      <CloudFolder ref="cloudFolder" :details="details" :key="$route.params.path || level" />
    </keep-alive>
  </div>
</template>
<script>
import CreateFile from "./Cloud/CreateFile.vue";
import CreateFolder from "./Cloud/CreateFolder.vue";
import CloudFolder from "./CloudFolder.vue";
export default {
  components: { CloudFolder, CreateFile, CreateFolder },
  data() {
    return {
      storedPaths: {},
      details: false,
    };
  },
  computed: {
    level() {
      return this.$route.params.level__uuid;
    },
    folder() {
      return (this.$route.params.path || "").split("&").at(-1);
    },
    previousFolder() {
      return (this.$route.params.path || "").split("&").at(-2);
    },
    cloudName() {
      return this.$store.getters["cloud/name"];
    },
  },
  methods: {
    addItem(item) {
      this.$refs.cloudFolder.addData(item);
    },
    onPrev() {
      const [first, ...newPath] = (this.$route.params.path || "").split("&");
      if (first) newPath.unshift(first);
      if (newPath.length === 1 && this.level === "null") {
        this.$router.push("/cloud");
        this.$store.commit("cloud/setName", "Select a Folder");
        return;
      }
      newPath.pop();
      if (newPath.length) {
        this.$router.push({
          name: "cloud-folder",
          params: {
            ...this.$route.params,
            path: newPath.join("&"),
          },
        });
      } else {
        this.$router.push(`/cloud/${this.level}/`);
        this.$store.commit("cloud/setName", "Select a folder");
      }
    },
  },
  watch: {
    cloudName(v) {
      this.storedPaths[this.folder] = v;
    },
  },
};
</script>
